import React, {Component} from 'react';

import CSSModules from 'react-css-modules'
// import Helmet from 'react-helmet'
import config from '../../config'
import {
  Link,
  LinkIcon,
  GetStartedInput,
  DonateBanner,
  SocialButtons
} from '../../components'
import Styles from './About.css'
import container from '../../helpers/container'

@CSSModules(Styles)
export default class About extends Component {
  constructor(props) {
    super(props)
    this.state = {}
  }
  renderTop = ()=>{
    return <Link strong={true} title='Back to top' to={'#top'}>Back to Top</Link>
  }
  renderAboutContent = (aboutTitle) => {
    const toIcon = require( '../../../static/images/icon-cigarette.svg' )
    const tmIcon = require( '../../../static/images/icon-cinema.svg' )
    return (
      <div styleName="about">
        <div styleName="about-inner">
          <h1 styleName='title'>{aboutTitle}</h1>
          { /* <div styleName='answer-title'>Overview</div> */ }
          <div styleName='answer-info'>
            <p><strong>Tobacco Free Funds</strong> empowers investors to search their mutual funds for tobacco companies and the entertainment companies that promote tobacco to young people. We help you identify investment options that align with your values and build a healthier future.</p>
            <p>We screen funds for two types of companies:</p>
            <div styleName='bullets'>
              <img src={toIcon} styleName='bullet-icn' alt='Tobacco manufacturers' />
              <div styleName='bullet-copy'><strong>Tobacco manufacturers.</strong> These companies&rsquo; largest source of revenue and income is the production, sale and/or marketing of cigarettes, cigars, and other tobacco products. Five tobacco firms dominate international markets: Phillip Morris International, Altria, British American Tobacco (which owns Reynolds American), Imperial Tobacco, and Japan Tobacco. Tobacco manufacturers are identified using Morningstar's industry classifications.</div>
            </div>
            <div styleName='bullets'>
              <img src={tmIcon} styleName='bullet-icn' alt='Entertainment companies' />
              <div styleName='bullet-copy'><strong>Entertainment companies that promote tobacco in kid-rated movies.</strong> “R”-rating future movies with smoking will prevent one million tobacco deaths in this generation of U.S. kids. Hollywood studios and their parent companies, the nation’s best-known entertainment companies, are well aware of the public health risk, but continue to intentionally expose millions of kids. To learn more about which entertainment companies we flag as tobacco-promoting, <Link to={config.routes.faq} xstrong={true} title='FAQ'>see the FAQ.</Link></div>
            </div>
            <p><strong>Tobacco Free Funds</strong> is funded in part by a grant from Truth Initiative.</p>
          </div>
          <Link
          to={config.routes.clean}
          title='Get started with Tobacco Free Funds'>
            <div styleName='link-style'>
              Get started<LinkIcon />
            </div>
          </Link>
        </div>
      </div>
    )
  }
  renderXPanels = () => {
    return (
      <div>
        <div styleName='x-401k-container'>
          <div styleName='x-401k-container-inner'>
            <div styleName='x-401k-info-photo'>
              <div styleName='x-401k-photo' title='Retirement plans image'/>
              <div styleName='x-401k-info'>
                <div styleName='x-401k-info-title'>Retirement plans</div>
                <p>Retirement plans invest mostly in mutual funds, which are themselves invested in a wide array of company stocks and other securities. It&rsquo;s not always easy for investors to investigate what’s inside the funds they own. Your retirement money may be invested in tobacco companies and entertainment companies that promote tobacco to kids. If you want tobacco-free options in your retirement account, <Link to={config.routes.toolkit} xstrong={true} title='401k toolkit'>talk to your plan administrator.</Link></p>
              </div>
            </div>
          </div>
        </div>
        <div styleName='x-ays-container'>
          <div styleName='x-ays-container-inner'>
            <div styleName='x-ays-info-photo'>
              <div styleName='x-ays-photo' title='As You Sow image'/>
              <div styleName='x-ays-info'>
                <div styleName='x-ays-info-title'>As You Sow</div>
                <p>At <Link to={config.links.ays} xstrong={true} title='As You Sow'>As You Sow,</Link> we&rsquo;ve been engaging major corporations on social and environmental responsibility since 1992. In 2015, we launched <Link to={config.links.fff} xstrong={true} title='Fossil Free Funds'>Fossil Free Funds</Link> so that people could see if their retirement was funding climate change. Since then our Invest Your Values program has released free sustainable investing tools on environmental and social issues like gender equality, deforestation, and more. We are committed to transparency, corporate accountability, and empowering individuals to take control of their investments.</p>
              </div>
            </div>
          </div>
        </div>
        <div styleName='x-desktop-container'>
          <div styleName='x-desktop-container-inner'>
            <div styleName='x-desktop-info-photo'>
              <div styleName='x-desktop-photo' title='Computer with Tobacco Free Funds image'/>
              <div styleName='x-desktop-info'>
                <div styleName='x-desktop-info-title'>How Tobacco Free Funds Works</div>
                <ul>
                  <li>Look up mutual funds using up-to-date Morningstar data</li>
                  <li>We analyze your investments for tobacco stocks</li>
                  <li>See how much exposure they have to tobacco and tobacco-promoting entertainment companies</li>
                </ul>
                <div styleName='x-desktop-link'>
                  <Link
                    to={config.routes.works}
                    title='How it works | Tobacco Free Funds'
                  >
                    <div styleName='press-link'>
                      See how it works<LinkIcon />
                    </div>
                  </Link>
                </div>
                <div styleName='x-desktop-info-title'>Use our action toolkit</div>
                <ul>
                  <li>Learn how to make a change and invest tobacco free</li>
                  <li>Ask your financial advisor about socially responsible investments</li>
                  <li>Push your employer to provide tobacco free 401(k) options</li>
                </ul>
                <div styleName='x-desktop-link'>
                  <Link
                    to={config.routes.toolkit}
                    title='Action toolkit | Tobacco Free Funds'
                  >
                    <div styleName='press-link'>
                      View the action toolkit<LinkIcon />
                    </div>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div styleName='img-attrib-container'>
          <div styleName='img-attrib-container-inner'>
            <Link
              to={config.routes.media}
              alt='Media | Tobacco Free Funds'
            >
              <div styleName='press-link'>
                Visit our media page<LinkIcon />
              </div>
            </Link>
          </div>
        </div>
      </div>
    )
  }
  render() {
    const title = 'About'
    const link = config.domain+config.routes.about
    const message = config.shareMessage
    return (
      <div>
        <div styleName="main">
          {container.helmet(title)}
          {this.renderAboutContent(title)}
          {this.renderXPanels()}
        </div>
        { /* <SocialButtons message={message} link={link}/> */ }
        <GetStartedInput />
        <DonateBanner />
      </div>
    )
  }
}
